<template>
    <div>
        <SelectField :options="items" layout="big" />
        <div class="legend mt32">Adicione um item por linha.</div>
        <textarea :value="options" class="optionsEditor mt8 mb8" ref="options"></textarea>
        <div class="actions">
            <Btn class="add-item-btn" type="outline" size="sm" @click.native="changeValue">Atualizar itens</Btn>
            <div class="tips">
                <Btn type="boxlink" class="btn-tip" size="xs" @click.native="addDefault('ufs')">Estados</Btn>
                <Btn type="boxlink" class="btn-tip" size="xs" @click.native="addDefault('countries')">Países</Btn>
                <Btn type="boxlink" class="btn-tip" size="xs" @click.native="addDefault('jobs')">Área de atuação</Btn>
            </div>
        </div>
    </div>
</template>

<script>
import TextareaField from './TextareaField.vue'
import Btn from './Btn.vue'
import SelectField from './SelectField.vue'
    export default {
        components: { SelectField, Btn, TextareaField },
        props: {
            data: {
                type: Array,
                default: []
            },
        },   
 
        computed: {
            options() {
                return this.arrayToLines(this.data) 
            },

            items(){
                return this.data
            }
        },

        mounted () {
            if(!this.items[0]) this.setStartValue()
        },

        watch: {
            items(value) {
                if(!value[0]) this.setStartValue() 
            }
        },

        methods: {
            setStartValue(){
                const defaultValues = ["Um", "Dois", "Três"]
                this.items.push(...defaultValues)
            },

            arrayToLines(items) {
                let string = '';
                items.forEach(element => {
                    if(element.label )string = string + element.label + "\n";                    
                    else string = string + element + "\n";                    
                });
                return string
            },

            stringToArray(string){
                const arr = string.split("\n")
                const arrWithoutEmptyLines = arr.filter(item => item)   
                const arrWithoutDuplicates = new Set(arrWithoutEmptyLines)
                return arrWithoutDuplicates
            },

            stringToObject(string){
                const arr = string.split("\n")
                return this.arrayToObject(arr)
            },

            arrayToObject(arr){
                let finalArray = []
                arr.forEach((item, index) => {
                    if(item != ''){
                        const obj = {label: item, key: "key-" + index}
                        finalArray.push(obj)
                    }
                })
                return finalArray
            },

            changeValue(){   
                const itemsObject = this.stringToObject(this.$refs.options.value) 
                this.replaceCurrentItems(itemsObject)
                this.$parent.$emit('save-form')
            },

            replaceCurrentItems(newItems){
                this.items.length = 0
                this.items.push(...newItems)
            },

            addDefault(set){
                const values = {
                    ufs: ['Acre','Alagoas','Amapá','Amazonas','Bahia','Ceará','Distrito Federal','Espirito Santo','Goiás','Maranhão','Mato Grosso do Sul','Mato Grosso','Minas Gerais','Pará','Paraíba','Paraná','Pernambuco','Piauí','Rio de Janeiro','Rio Grande do Norte','Rio Grande do Sul','Rondônia','Roraima','Santa Catarina','São Paulo','Sergipe','Tocantins'],
                    countries: ["Afeganistão","África do Sul","Albânia","Alemanha","Andorra","Angola","Anguilla","Antártida","Antígua e Barbuda","Antilhas Holandesas","Arábia Saudita","Argélia","Argentina","Armênia","Aruba","Austrália","Áustria","Azerbaijão","Bahamas","Bahrein","Bangladesh","Barbados","Belarus","Bélgica","Belize","Benin","Bermudas","Bolívia","Bósnia-Herzegóvina","Botsuana","Brasil","Brunei","Bulgária","Burkina Fasso","Burundi","Butão","Cabo Verde","Camarões","Camboja","Canadá","Cazaquistão","Chade","Chile","China","Chipre","Cingapura","Colômbia","Congo","Coréia do Norte","Coréia do Sul","Costa do Marfim","Costa Rica","Croácia (Hrvatska)","Cuba","Dinamarca","Djibuti","Dominica","Egito","El Salvador","Emirados Árabes Unidos","Equador","Eritréia","Eslováquia","Eslovênia","Espanha","Estados Unidos","Estônia","Etiópia","Fiji","Filipinas","Finlândia","França","Gabão","Gâmbia","Gana","Geórgia","Gibraltar","Grã-Bretanha (Reino Unido, UK)","Granada","Grécia","Groelândia","Guadalupe","Guam (Território dos Estados Unidos)","Guatemala","Guernsey","Guiana","Guiana Francesa","Guiné","Guiné Equatorial","Guiné-Bissau","Haiti","Holanda","Honduras","Hong Kong","Hungria","Iêmen","Ilha Bouvet (Território da Noruega)","Ilha do Homem","Ilha Natal","Ilha Pitcairn","Ilha Reunião","Ilhas Aland","Ilhas Cayman","Ilhas Cocos","Ilhas Comores","Ilhas Cook","Ilhas Faroes","Ilhas Falkland (Malvinas)","Ilhas Geórgia do Sul e Sandwich do Sul","Ilhas Heard e McDonald (Território da Austrália)","Ilhas Marianas do Norte","Ilhas Marshall","Ilhas Menores dos Estados Unidos","Ilhas Norfolk","Ilhas Seychelles","Ilhas Solomão","Ilhas Svalbard e Jan Mayen","Ilhas Tokelau","Ilhas Turks e Caicos","Ilhas Virgens (Estados Unidos)","Ilhas Virgens (Inglaterra)","Ilhas Wallis e Futuna","índia","Indonésia","Irã", "Iraque", "Irlanda", "Islândia", "Israel", "Itália", "Jamaica", "Japão", "Jersey", "Jordânia", "Kênia","Kiribati","Kuait","Laos","Látvia","Lesoto","Líbano","Libéria","Líbia","Liechtenstein","Lituânia","Luxemburgo","Macau","Macedônia (República Yugoslava)","Madagascar","Malásia","Malaui","Maldivas","Mali","Malta","Marrocos","Martinica","Maurício","Mauritânia","Mayotte","México","Micronésia","Moçambique","Moldova","Mônaco","Mongólia","Montenegro","Montserrat","Myanma","Namíbia","Nauru","Nepal","Nicarágua","Níger","Nigéria","Niue","Noruega","Nova Caledônia","Nova Zelândia","Omã","Palau","Panamá","Papua-Nova Guiné","Paquistão","Paraguai","Peru","Polinésia Francesa","Polônia","Porto Rico","Portugal","Qatar","Quirguistão","República Centro-Africana","República Democrática do Congo","República Dominicana","República Tcheca","Romênia","Ruanda","Rússia (antiga URSS) - Federação Russa","Saara Ocidental","Saint Vincente e Granadinas","Samoa Americana","Samoa Ocidental","San Marino","Santa Helena","Santa Lúcia","São Bartolomeu","São Cristóvão e Névis","São Martim","São Tomé e Príncipe","Senegal","Serra Leoa","Sérvia","Síria","Somália","Sri Lanka","St. Pierre and Miquelon","Suazilândia","Sudão","Suécia","Suíça","Suriname","Tadjiquistão","Tailândia","Taiwan","Tanzânia","Território Britânico do Oceano índico","Territórios do Sul da França","Territórios Palestinos Ocupados","Timor Leste","Togo","Tonga","Trinidad and Tobago","Tunísia","Turcomenistão","Turquia","Tuvalu","Ucrânia","Uganda","Uruguai","Uzbequistão","Vanuatu","Vaticano","Venezuela","Vietnã","Zâmbia","Zimbábue"],
                    jobs: ["Acústica","Administração","aeronaves","Aeronáutica","Aeronáuticas","Agrimensura","Agroecologia","Agronegócios","Agronomia","Agropecuária","Agrárias","Agrícola","Alimentos","Ambiental","Animação","Aquicultura","Arqueologia","Arquitetura","Arquivologia","Arte","Artes","Astronomia","Atuariais","Audiovisual","Automação","Banco","Bebidas","Biblioteconomia","Biocombustíveis","Biológicas","Biomedicina","Biomédica","Biomédicos","Bioprocessos","Bioquímica","Bioquímica,","Biossistemas","Biotecnologia","Cartográfica","Celulose","Cinema","Civil","Ciência","Ciências","Coletiva","Comercial","Computadores","Computação","Comunicação","Comércio","Conservação","Construção","Consumo","Controle","Contábeis","Cooperativas","Cooperativismo","Corpo","Cosmética","Criativa","Cultural","Cênica","da","Dados","Dança","das","de","Defesa","Design","Desportiva","Digitais","Direito","Diversidade","do","Drenagem","e","Ecologia","Econômicas","Editorial","Educação","Educomunicação","Eletrotécnica","Eletrônica","Elétrica","Elétricos","em","Embarcados","Energia","Energias","Enfermagem","Engenharia","Escrita","Esporte","Estatística","Estratégica","Estudos","Estética","Eventos","Exatas","Executivo","Exterior","Fabricação","Farmácia","Filosofia","Financeira","Fisioterapia","Florestal","Fonoaudiologia","Fonográfica","Fotografia","Física","Games","Gastronomia","Geofísica","Geografia","Geologia","Geoprocessamento","Gerenciais","Gerontologia","Gestão","Gás","Gênero","História","Hospitalar","Hotelaria","Humanas","Humanos","Hídrica","Imobiliários","Industrial","Informação","Informática","Inovação","Institucional","Interiores","Internacionais","Internacional","Internet","Intérprete","Irrigação","Jogos","Jornalismo","Judiciários","Lazer","Letras","Libras","Linguística","Logística","Luteria","Madeireira","Manutenção","Marketing","Matemática","Materiais","Mecatrônica","Mecânica","Medicina","Metalúrgica","Metalúrgicos","Meteorologia","Minas","Mineração","Mobilidade","Moda","Multimídia","Museologia","Musicoterapia","Mídia","Mídias","Música","Nanotecnologia","Naturais","Naturologia","Naval","Negócios","no","Notariais","Nuclear","Nutrição","Obstetrícia","Oceanografia","Ocupacional","Odontologia","Oftálmica","Optometria","Organizacional","Ornamentais","Papel","para","Pedagogia","Pesca","Petróleo","Pilotagem","Privada","Processos","Produção","profissional","Propaganda","Psicologia","Psicopedagogia","Publicidade","Publicitária","Pública","Públicas","Qualidade","Quiropraxia","Química","Químicos","Radiologia","Recursos","Redes","Relações","Renováveis","Restauro","Rochas","Rádio,","Saneamento","Sanitária","Saúde","Secretariado","Segurança","Seguros","Serviço","Serviços","Silvicultura","Sistemas","Sociais","Social","Software","Sucroalcooleira","Teatro","Tecnologia","Telecomunicações","Teologia","Terapia","Trabalho","Tradutor","Transporte","Turismo","TV","Têxtil","Urbanismo","Veterinária","Visuais","Zootecnia",],
                }      
                this.replaceCurrentItems(values[set])          
            }
        },   
    }
</script>

<style lang="sass" scoped>
    .optionsEditor
        padding: $mgXs $mgSm
        height: 200px
        width: 100%
        border: 1px solid $cG3
        border-radius: 4px
        font-family: $sans
        line-height: 160%

    .legend
        font-size: $fzSm
        color: $cG3

    .actions
        display: flex
        align-items: center
        justify-content: space-between

        .deafultItem
            color: rgba($cFormQuestion, 1)
            cursor: pointer

    .btn-tip::v-deep .btn,
    .add-item-btn::v-deep .btn
        color: rgba($cFormQuestion, 1)
        border-color: rgba($cFormQuestion, 1)

        &:hover
            background-color: rgba($cFormQuestion, .1)



</style>